import React, { useEffect, useState } from 'react';
import { Modal, Box, } from '@mui/material';
import Loading from '../Input/Loading.js';
import CustomTextField from '../Input/input.jsx';
import cancelIcon from '../../Assets/Images/cancelIcon.svg'
import { Link } from 'react-router-dom';
import Button from '../Input/Button.js';
import postService from '../../Services/post-service.js';
import { toast } from 'react-toastify';
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  // p: 4,
};

const PurchaseEpin = ({ open, handleClose }) => {
  const [unit, setUnit] = useState('')
  const [price, setPrice] = useState('')
  const [des, setDes] = useState('')
  const [pin, setPin] = useState('')
  const [loading, setLoading] = useState('')

  const onSubmit = (e) =>{
    e.preventDefault()
    setLoading(true)
    postService.createEpin(des,pin,unit,price).then(
        (response) => {
            console.log(response.data)
            setLoading(false)
           if(response.data.status === '2000'){
            toast.success(response.data.description)
            setTimeout(() => {
                window.location.reload()
              }, 2000);
           }else{  
          
            toast.error(response.data.description,)
           }
           
          },
          (error) => {
            setLoading(false)
              return  toast.error('Error. Try again',)
            }
      )
}
    
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
    >
  

        <Box sx={modalStyle} className='rounded-lg p-5 w-full'>
        <Loading
          open={loading}
        />
        <header className='flex justify-between items-center mb-10 py-5 px-3 bg-white shadow-sm w-full fixed top-0 left-0 h-[60px] z-10 rounded-lg'>
       

        <h1 className='text-custom-black text-[18px] font-[700]'>
        Fund Wallet
        </h1>
        <Link className='cursor-pointer' onClick={handleClose}>
        <img src={cancelIcon} alt="" />
        </Link>

      </header>
       <form className=' pt-6' onSubmit={onSubmit}>

      
        <CustomTextField
          label="Unit" 
          type="number"
           margin="normal"
           required
          value={unit}
           onChange={setUnit}
          />
          <div>
            <select className='bg-[#F2F4F7] rounded-md my-3 w-full p-4'
                  required
                  value={price}
                  onChange={(e) =>setPrice(e.target.value)}>
              <option value={''}>Select price</option>
              <option value={'200'}>200</option>
              <option value={'500'}>500</option>
              <option value={'750'}>750</option>
            </select>
          </div>
          <CustomTextField
          label="Description" 
          type="text"
          required
           margin="normal"
          value={des}
           onChange={setDes}
          />
          <CustomTextField
          label="Pin" 
          maxlength="4" 
          inputmode="numeric" 
          pattern="\d{4}" 
          type='password'
          required
           margin="normal"
          value={pin}
           onChange={setPin}
          />
          <div className='mt-2'>
            <Button
              name={'Submit'}
            />
          </div>
           </form>
       
        </Box>
    </Modal>
  );
};

export default PurchaseEpin;
